// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_ju-0";